<template>
  <div class="addTask">
    <el-form :model="form" ref="form" :rules="rules" label-width="90px">
      <el-row>
        <el-form-item label="区县街道:">
          <el-select
            style="height: auto"
            v-model="form.roadNameOne"
            placeholder="请选择"
            @change="changeRoadOne"
          >
            <el-option
              v-for="item in roadList"
              :key="item.roadId"
              :label="item.roadName"
              :value="item.roadId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="道路小区:">
          <el-select
            style="height: auto"
            v-model="form.roadName"
            placeholder="请选择"
            @change="changeRoad"
          >
            <el-option
              v-for="(item, index) in roadListOne"
              :key="index"
              :label="item.roadName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button
            style="margin-left: 20px"
            type="primary"
            plain
            @click="addRoad"
          >
            新增道路(小区)
          </el-button>
        </el-form-item>
      </el-row>

      <el-row>
        <el-form-item label="任务时长">
          <el-date-picker
            v-model="form.date"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 428px"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="班组">
          <el-radio-group
            :disabled="form.date.length != 2"
            v-model="form.groupId"
            @change="changeGroup"
          >
            <el-radio v-for="item in groupList" :key="item.id" :label="item.id"
              >{{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="车辆分配">
          <div
            class="carItem2"
            v-for="(item, index) in carList"
            :key="'car2222' + index"
          >
            <div class="carType">
              {{ item.carTypeName }}
            </div>
            <div class="carInfo">
              <div class="carNumber">{{ item.carNum }}</div>
              <div class="carTip">
                <div class="tips waring" v-if="item.carMark === 0">固</div>
                <div class="tips primary" v-if="item.carMark === 1">流</div>
                <div class="tips success" v-if="item.illegalStatus != null">
                  保
                </div>
                <div class="tips danger" v-if="item.usageStatus === 2">修</div>
              </div>
            </div>
            <div class="carGroup">
              <div>{{ item.groupName }} - {{ item.driverName }}</div>
              <div
                style="margin-right: 10px; color: #f56c6c; cursor: pointer"
                @click="delCar(index)"
              >
                删除
              </div>
            </div>
          </div>
          <el-button
            style="vertical-align: top; height: 60px"
            type="primary"
            plain
            @click="addCar"
            >+ 新增车辆
          </el-button>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="任务类型">
          <el-radio-group v-model="form.workId">
            <el-radio v-for="item in workType" :key="item.id" :label="item.id"
              >{{ item.workName }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-row>
      <!-- 年度选择（方案B显示） -->
      <el-row v-if="yearScheme === 'b'">
        <el-form-item label="所属年度" prop="year">
          <el-select v-model="form.year" placeholder="请选择年度">
            <el-option
              v-for="year in availableYears"
              :key="year"
              :label="year + '年'"
              :value="year"
            ></el-option>
          </el-select>
          <span class="scheme-tag">方案B-任务级年度</span>
        </el-form-item>
      </el-row>

      <!-- 方案A显示项目年度（只读） -->
      <el-row v-if="yearScheme === 'a'">
        <el-form-item label="所属年度">
          <el-input v-model="form.year" disabled style="width: 200px;"></el-input>
          <span class="scheme-tag">方案A-项目级年度</span>
        </el-form-item>
      </el-row>

      <el-row>
        <!-- item in workType -->
        <el-form-item label="任务说明">
          <el-input
            type="textarea"
            :rows="3"
            style="width: 500px"
            v-model="form.explains"
          ></el-input>
        </el-form-item>
      </el-row>
    </el-form>

    <div>
      <el-button type="primary" @click="submit">确定</el-button>
      <el-button @click="$router.back()" plain>取消</el-button>
    </div>
    <el-dialog
      :visible.sync="carVisible"
      title="选择车辆"
      width="650px"
      @close="closeDialog"
    >
      <div style="display: flex; flex-direction: row">
        <div
          class="type"
          @click="chooseCarType(0)"
          :class="{ choose: type === 0 }"
        >
          固定车辆
        </div>
        <div
          class="type"
          @click="chooseCarType(1)"
          :class="{ choose: type === 1 }"
        >
          流动车辆
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          margin-top: 20px;
        "
      >
        <div
          class="carItem"
          v-for="(item, index) in addCarList"
          :key="'car' + index"
          :class="{
            gray: item.usageStatus != 0,
            choosedCar: item.carId === selectCar.carId,
          }"
          @click="chooseCar(index, item)"
        >
          <div class="carType">
            {{ item.carTypeName }}
          </div>
          <div class="carInfo">
            <div class="carNumber">{{ item.carNum }}</div>
            <div class="carTip">
              <div class="tips waring" v-if="item.carMark === 0">固</div>
              <div class="tips primary" v-if="item.carMark === 1">流</div>
              <div class="tips success" v-if="item.illegalStatus != null">
                保
              </div>
              <div class="tips danger" v-if="item.usageStatus === 2">修</div>
            </div>
          </div>
          <div class="carGroup">
            {{ item.groupName }} - {{ item.driverName }}
          </div>
        </div>
      </div>

      <div style="margin-top: 20px">
        <el-button type="primary" @click="submitCar">确定</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="addRoadVisible"
      title="新增道路(小区)"
      width="380px"
      @close="closeDialog"
    >
      <el-select
        style="width: 288px"
        v-model="addRoadForm.townName"
        filterable
        remote
        reserve-keyword
        placeholder="请选择区域"
        @change="changeArea"
      >
        <el-option
          v-for="item in areaList"
          :key="item.dictValue"
          :label="item.dictName"
          :value="item"
        ></el-option>
      </el-select>
      <el-input
        style="width: 288px; margin-top: 10px"
        v-model="addRoadForm.roadName"
        placeholder="请输入道路(小区)名称"
      ></el-input>
      <div style="margin-top: 20px">
        <el-button type="primary" @click="submitAddRoad">确定</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TaskDispatchApi from '@/api/taskDispatch';
import TeamGroupApi from '@/api/teamGroup';
import ProjectApplyApi from '@/api/projectApply';
import CommonApi from '@/api/common';
import { queryRoadByTownCode } from '@/api/dataV';

export default {
  name: 'AddTask',
  data() {
    return {
      areaList: [],
      addRoadForm: {
        roadName: '',
        townCode: '',
        townName: '',
      },
      selectCar: {},
      roadListOne: [],
      addRoadVisible: false,
      carVisible: false,
      type: 0,
      addCarList: [],
      workType: [],
      groupList: [],
      roadList: [],
      carList: [],
      rules: {},
      // 年度相关
      yearScheme: null, // 'a'=方案A, 'b'=方案B
      projectYear: null, // 方案A：项目年度
      availableYears: [], // 方案B：可选年度列表
      form: {
        roadNameOne: '',
        roadName: '',
        date: [],
        carDtos: [
          {
            carId: 13,
            carNum: '3333',
            carTypeName: '哈弗SUV',
            deptName: '项目二部',
            carMark: 1,
            groupId: 0,
            groupName: '',
            groupManager: null,
            driverName: 'ouyang ',
            cameraNo: 0,
            endDate: null,
            company: null,
            repairDate: null,
            distance: null,
            illegalStatus: null,
            number: null,
            illegalCount: null,
            startTime: null,
            endTime: null,
            useReason: null,
            usageStatus: 0,
          },
          //   {
          //     carId: 0,
          //     carMark: 0,
          //     carNo: "",
          //     carType: 0,
          //     carTypeName: "",
          //     driverId: 0,
          //     driverName: "",
          //     groupId: 0,
          //     groupName: "",
          //   },
        ],
        listTypeOne: '',
        endTime: '',
        groupId: 0,
        groupManageId: '',
        groupManageName: '',
        groupName: '',
        projectId: '',
        roadId: '',
        roadName: '',
        startTime: '',
        workId: '',
        workName: '',
        year: '', // 所属年度
      },
    };
  },
  filters: {
    filterCarType(val) {
      return val;
    },
  },
  mounted() {
    this.getWorkType();
    this.getGroupList();
    this.getDetail();
    this.getDictList();
    this.initYearScheme();
  },
  methods: {
    queryRoadByTownCode() {
      //根据道路ID查询管道管井信息
      queryRoadByTownCode({
        townCode: this.form.roadIdOne,
      }).then((res) => {
        if (res.data.code === 200) {
          this.roadListOne = res.data.data;
        }
      });
    },
    getDictList() {
      ProjectApplyApi.getDictList({
        dictCode: 'town_code',
      }).then((res) => {
        if (res.data.code === 200) {
          this.areaList = res.data.data;
        }
      });
    },
    changeArea(value) {
      this.addRoadForm.townCode = value.dictCode;
      this.addRoadForm.townName = value.dictName;
    },
    // 初始化年度方案
    initYearScheme() {
      const type = this.$route.query.type;
      if (type === 'a') {
        // 方案A：项目级年度
        this.yearScheme = 'a';
        this.projectYear = this.$route.query.year || new Date().getFullYear();
        this.form.year = this.projectYear;
        console.log('方案A-项目级年度:', this.projectYear);
      } else if (type === 'b') {
        // 方案B：任务级年度
        this.yearScheme = 'b';
        const yearsParam = this.$route.query.years;
        if (yearsParam) {
          this.availableYears = yearsParam.split(',').map(y => parseInt(y.trim()));
        } else {
          // 默认提供当前年度及前后两年
          const currentYear = new Date().getFullYear();
          this.availableYears = [currentYear - 1, currentYear, currentYear + 1];
        }
        // 默认选中当前年度
        this.form.year = this.availableYears[1] || this.availableYears[0];
        console.log('方案B-任务级年度，可选年度:', this.availableYears);
      }
    },
    submitAddRoad() {
      if (this.addRoadForm.roadName === '') {
        this.$message({ message: '请输入地域范围', type: 'error' });
        return;
      }

      this.areaList.forEach((value, idnex) => {
        if (value.dictName === this.addRoadForm.townName) {
          this.addRoadForm.townCode = value.dictValue;
        }
      });

      CommonApi.saveRoad(this.addRoadForm).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: '地域范围添加成功，请进入选择页面选择',
            type: 'success',
          });
          this.addRoadVisible = false;
          this.queryRoadByTownCode();
        } else {
          this.$message({ message: res.data.message, type: 'error' });
          this.addRoadVisible = false;
        }
      });
    },
    addRoad() {
      this.addRoadVisible = true;
      this.addRoadForm = {
        roadName: '',
        townCode: '',
        townName: '',
      };
    },
    chooseCar(index, item) {
      if (item.usageStatus === 0) {
        this.selectCar = this.addCarList[index];
      }
    },
    addCar() {
      //先选班组
      if (this.form.date.length != 2) {
        this.$message({
          message: '请先选择任务时长',
          type: 'error',
        });
        return;
      }
      this.carVisible = true;
      this.getCar2();
    },
    chooseCarType(val) {
      this.type = val;
      this.getCar2();
    },
    getCar2() {
      TaskDispatchApi.listCar({
        current: 0,
        carMark: this.type,
        size: 1000,
        startTime: this.form.date[0],
        endTime: this.form.date[1],
      }).then((res) => {
        if (res.data.code === 200) {
          this.addCarList = res.data.data;
        }
      });
    },
    submitCar() {
      if (JSON.stringify(this.selectCar) === '{}') {
        this.$message({
          message: '请选择车辆',
          type: 'error',
        });
        return;
      }
      if (
        !this.carList.some((item) => {
          return item.carId === this.selectCar.carId;
        })
      ) {
        this.carList.push(JSON.parse(JSON.stringify(this.selectCar)));
      }
      this.carVisible = false;
      this.$nextTick(() => {
        this.selectCar = {};
      });
    },
    closeDialog() {
      this.carVisible = false;
      this.addRoadVisible = false;
    },
    changeRoadOne(val) {
      this.form.roadIdOne = val;
      // this.form.roadNameOne = val.roadName;
      this.queryRoadByTownCode();
    },
    changeRoad(val) {
      const item = this.roadListOne.filter((item) => item.id === val);
      console.log(item);
      this.form.roadName = item[0].roadName;
      this.form.roadId = item[0].id;
    },
    submit() {
      if (this.form.roadName === '') {
        this.$message({ message: '请选择地域范围', type: 'error' });
        return;
      }

      this.form.projectId = this.$route.query.id;
      //   if (this.form.date[0].length === 10) {
      this.form.startTime = this.form.date[0];
      this.form.endTime = this.form.date[1];

      if (this.form.date.length === 0) {
        this.$message({ message: '请选择任务时长', type: 'error' });
        return;
      }

      this.workType.forEach((item) => {
        if (item.id === this.form.workId) {
          this.form.workName = item.workName;
        }
      });

      if (this.form.groupId === 0) {
        this.$message({ message: '请选择班组', type: 'error' });
      }

      this.groupList.forEach((item) => {
        if (item.id === this.form.groupId) {
          this.form.groupName = item.name;
          this.getGroupPeople();
        }
      });
    },
    changeGroup(val) {
      this.getCar(val);
    },
    getCar(id) {
      this.carList = [];
      TaskDispatchApi.listCar({
        current: 0,
        groupId: id,
        size: 1000,
        startTime: this.form.date[0],
        endTime: this.form.date[1].substring(0, 10) + ' 23:59:59',
      }).then((res) => {
        if (res.data.code === 200) {
          res.data.data.forEach((item) => {
            if (item.usageStatus === 0) {
              this.carList.push(item);
            }
          });
        }
      });
    },
    getWorkType() {
      TaskDispatchApi.queryAllWorkInfo().then((res) => {
        this.workType = res.data.data;
      });
    },
    getGroupList() {
      TeamGroupApi.getGroupInfo().then((res) => {
        if (res.data.code === 200) {
          this.groupList = res.data.data;
        }
      });
    },
    getDetail() {
      TaskDispatchApi.getProjectDetail({
        projectId: this.$route.query.id,
        current: 0,
        size: 0,
      }).then((res) => {
        if (res.data.code === 200) {
          console.log(res.data.data);

          this.roadList = res.data.data.busProjectRoads;
        }
      });
    },

    getGroupPeople() {
      //   this.query.groupId = this.selectGroup.id;
      TeamGroupApi.getEmployeeByGroupId({
        groupId: this.form.groupId,
        employeeInfos: '',
        pageDto: {
          current: 0,
          size: 10000,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          // console.log(res.data.data.records);
          
          res.data.data.records.forEach((item) => {
            //1 班组组长
            if (item.managerMark === 1) {
              //   this.leaderList.push(item);
              this.form.groupManageId = item.id;
              this.form.groupManageName = item.name;
            }
          });
        }

       this.addTask();
      });
    },
    delCar(index) {
      this.carList.splice(index, 1);
    },
    addTask() {
      let { date, ...newForm } = this.form;
      newForm.carDtos = this.carList;
      console.log(newForm);
      
      TaskDispatchApi.addTask(newForm).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$router.back();
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.addTask {
  padding: 20px;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;

  .type {
    width: 100px;
    height: 30px;
    line-height: 30px;
    color: black;
    cursor: pointer;
  }

  .choose {
    color: #409eff;
  }

  .gray {
    div {
      color: #ccc;
    }
  }

  .choosedCar {
    border: 1px solid #409eff !important;
  }

  .carItem {
    width: 46%;
    height: 60px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;

    .carType {
      float: right;
      height: 30px;
      line-height: 30px;
      margin-right: 10px;
    }

    .carInfo {
      height: 30px;
      line-height: 30px;
      margin-left: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .carNumber {
        font-weight: 600;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
      }

      .tips {
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        border-radius: 2px;
        color: white;
        margin-left: 4px;
      }

      .success {
        background-color: #67c23a;
      }

      .waring {
        background-color: #e6a23c;
      }

      .danger {
        background-color: #f56c6c;
      }

      .primary {
        background-color: #409eff;
      }
    }

    .carGroup {
      margin-left: 10px;
    }
  }

  .carItem2 {
    display: inline-block;
    width: 300px;
    height: 60px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 10px;
    margin-bottom: 10px;

    .carType {
      float: right;
      height: 30px;
      line-height: 30px;
      margin-right: 10px;
    }

    .carInfo {
      height: 30px;
      line-height: 30px;
      margin-left: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .carNumber {
        font-weight: 600;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
      }

      .tips {
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        border-radius: 2px;
        color: white;
        margin-left: 4px;
      }

      .success {
        background-color: #67c23a;
      }

      .waring {
        background-color: #e6a23c;
      }

      .danger {
        background-color: #f56c6c;
      }

      .primary {
        background-color: #409eff;
      }
    }

    .carGroup {
      margin-left: 10px;
      height: 30px;
      line-height: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .scheme-tag {
    margin-left: 15px;
    padding: 2px 8px;
    background-color: #409EFF;
    color: white;
    border-radius: 4px;
    font-size: 12px;
  }
}
</style>
